import axios from 'axios';
import { SignTDMfileUploadPayload } from '../types/Asset';
import { baseUrl, HttpMethods } from './base';

export async function getSignAssetsKey(params: { key: string }) {
  const res = await axios.request<{ url: string }>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/assets/protected/sign`,
    params,
  });
  return res.data;
}

export interface SignAssetUploadPayload {
  key: string;
  type: string;
  resource: string;
  resourceId: number;
  path?: string;
}

export async function signAssetUpload(data: SignAssetUploadPayload) {
  const res = await axios({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/assets/upload/sign`,
    data,
  });
  return res.data;
}

export async function signAsset(data: {
  key: string;
  type: string;
  resource?: string;
  resourceId?: number | string;
  path?: string;
}) {
  const res = await axios({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/assets/upload/sign`,
    data,
  });
  return res.data;
}

interface SignTDMAssetService {
  data: SignTDMfileUploadPayload;
  tdmId: number;
}
export async function signTDMAsset({ tdmId, data }: SignTDMAssetService) {
  const res = await axios({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/assets/upload/tdm/${tdmId}/sign`,
    data,
  });
  return res.data;
}
